const ARABIC_SCRIPT_PATTERN =
  /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+/g;
const LATIN_RUN_PATTERN = /[A-Za-z0-9][A-Za-z0-9\s.,'()\-/%]*/g;

/**
 * Split text into Arabic and Latin runs so react-pdf can render each with the correct font
 * and direction. Mixed runs in a single Text node produce garbled Arabic output.
 */
export const splitPdfBidiSegments = (text) => {
  if (text == null || text === "") {
    return [];
  }

  const value = String(text);
  const segments = [];
  const pattern = new RegExp(
    `${ARABIC_SCRIPT_PATTERN.source}|${LATIN_RUN_PATTERN.source}`,
    "g"
  );
  let lastIndex = 0;
  let match = pattern.exec(value);

  while (match) {
    if (match.index > lastIndex) {
      segments.push({
        text: value.slice(lastIndex, match.index),
        isLatin: false,
      });
    }

    const chunk = match[0];
    segments.push({
      text: chunk,
      isLatin: /^[A-Za-z0-9]/.test(chunk),
    });
    lastIndex = match.index + chunk.length;
    match = pattern.exec(value);
  }

  if (lastIndex < value.length) {
    segments.push({
      text: value.slice(lastIndex),
      isLatin: false,
    });
  }

  const normalized = [];
  segments.forEach((segment) => {
    const previous = normalized[normalized.length - 1];
    if (previous && !previous.isLatin && !segment.isLatin) {
      previous.text += segment.text;
      return;
    }
    normalized.push({ ...segment });
  });

  return normalized.length ? normalized : [{ text: value, isLatin: false }];
};
